import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  AfterViewInit,
  input,
  viewChild
} from "@angular/core";

@Component({
  selector: "av-card-header",
  templateUrl: "./card-header.component.html",
  styleUrls: ["./card-header.component.scss"],
  standalone: false,
})
export class CardHeaderComponent implements OnInit, AfterViewInit {
  readonly subtitle = input<string>(undefined);
  readonly autofocus = input(true);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close: EventEmitter<Event> = new EventEmitter();

  readonly closeBtn = viewChild("closeBtn", { read: ElementRef });

  isCloseVisible = false;
  constructor() {}

  ngOnInit(): void {
    this.isCloseVisible = this.close.observers.length > 0;
  }

  ngAfterViewInit(): void {
    if (this.autofocus()) this.closeBtn()?.nativeElement?.focus();
  }

  @HostListener("document:keydown.escape", ["$event"]) keydown(
    e: KeyboardEvent
  ) {
    if (this.isCloseVisible) {
      this.cancel(e);
    }
  }

  cancel(e) {
    this.close.emit(e);
  }
}
